import React from 'react'
import './ConfirmationPopup.css'
function DisclaimerPopup(props) {

  return (
    <div className='ConfirmationPopup' >
       <div className='ConfirmationPopup-overlay' onClick={()=>props.onClose()}/>
       
            <div className='Confirm-Body'>
            <div className='Cross-div' onClick={()=>props.onClose()}>
                        <img src='/assets/CrossPopup.png' className='Cross'/>
                    </div>
                <div className='Confirm-inner-body'>
                   
            <p className='heading'>Disclaimer</p>
            
           
    
    <p className='subtext' >Both the GoldBux and EggBux tokens are associated with Egg Heads Club (an NFT project), although this platform itself is not ran or managed by the Egg Heads Club team. The team kindly gifted us a portion of these tokens, and we have subsequently used them to set up this platform. 
    <br/><br/>  
For any conversion of EggBux to GoldBux, there will be a 10% tax applied - this amount is to be gifted back to the Egg Heads Club team to redistribute via their tokenomics system. For any conversion of GoldBux to EggBux, there will be no tax applied.</p>
 
            </div>
            </div>
       
    </div>
  )
}

export default DisclaimerPopup